import gql from "graphql-tag";
import applicantFragment from "../fragments/applicantFragment";
import anyUserFragment from "../fragments/anyUserFragment";
import universityUserFragment from "../fragments/universityUserFragment";
import mentorFragment from "../fragments/mentorFragment";
import staffFragment from "../fragments/staffFragment";

const getTokenQuery = gql`
    query GetTokenQuery($email: String, $password: String, $redirectUrl: String, $rootUrl: String) {
        getToken(email: $email, password: $password, redirectUrl: $redirectUrl, rootUrl: $rootUrl) {
            accessToken
            me {
                anyUser {
                    ...AnyUserFull
                }
                admin {
                    id
                    firstName
                    lastName
                }
                mentor {
                    ...MentorFull
                }
                applicant {
                    ...ApplicantFull
                }
                universityUser {
                    ...UniversityUserFull
                }
                staff {
                    ...StaffFull
                }
            }
        }
    }
    ${anyUserFragment}
    ${applicantFragment}
    ${mentorFragment}
    ${universityUserFragment}
    ${staffFragment}
`;

export default getTokenQuery;
